export default __webpack_public_path__ + "static/media/steve.61c4afe2.png";